import * as z from "zod";

export const refundExchangeShipping = {
  name: "refundExchangeShipping" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
